var _circle, _circle2, _line, _line2, _circle3, _circle4, _line3, _line4, _circle5, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _circle6, _line12, _circle7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicroserviceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 602,
    height: 617,
    viewBox: "0 0 602 617",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 155,
    r: 52.5,
    stroke: "#1F9A73",
    strokeWidth: 7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 451,
    r: 52.5,
    stroke: "#1F9A73",
    strokeWidth: 7
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 121.2,
    y1: 208.807,
    x2: 227.2,
    y2: 266.807,
    stroke: "#1F9A73",
    strokeWidth: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 126.663,
    y1: 405.887,
    x2: 224.663,
    y2: 343.887,
    stroke: "#1F9A73",
    strokeWidth: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 540.506,
    cy: 461.697,
    r: 52.5,
    transform: "rotate(-179.256 540.506 461.697)",
    stroke: "#1F9A73",
    strokeWidth: 7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.348,
    cy: 165.722,
    r: 52.5,
    transform: "rotate(-179.256 544.348 165.722)",
    stroke: "#1F9A73",
    strokeWidth: 7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 476.01,
    y1: 407.049,
    x2: 370.772,
    y2: 347.678,
    stroke: "#1F9A73",
    strokeWidth: 5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 473.105,
    y1: 209.914,
    x2: 374.308,
    y2: 270.637,
    stroke: "#1F9A73",
    strokeWidth: 5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 56,
    r: 52.5,
    stroke: "#1F9A73",
    strokeWidth: 7
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 300.5,
    y1: 128,
    x2: 300.5,
    y2: 221,
    stroke: "#1F9A73",
    strokeWidth: 5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 547.5,
    y1: 268,
    x2: 547.5,
    y2: 361,
    stroke: "#1F9A73",
    strokeWidth: 5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 390.981,
    y1: 79.7007,
    x2: 472.981,
    y2: 114.701,
    stroke: "#1F9A73",
    strokeWidth: 5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 388.926,
    y1: 540.742,
    x2: 470.926,
    y2: 501.742,
    stroke: "#1F9A73",
    strokeWidth: 5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 130.178,
    y1: 110.639,
    x2: 219.178,
    y2: 79.6391,
    stroke: "#1F9A73",
    strokeWidth: 5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 134.981,
    y1: 501.701,
    x2: 216.981,
    y2: 536.701,
    stroke: "#1F9A73",
    strokeWidth: 5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 61.5,
    y1: 259,
    x2: 61.5,
    y2: 352,
    stroke: "#1F9A73",
    strokeWidth: 5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.289,
    cy: 559.998,
    r: 52.5,
    transform: "rotate(179.704 298.289 559.998)",
    stroke: "#1F9A73",
    strokeWidth: 7
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 295.417,
    y1: 488.012,
    x2: 294.935,
    y2: 395.013,
    stroke: "#1F9A73",
    strokeWidth: 5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 305,
    r: 52.5,
    stroke: "#1F9A73",
    strokeWidth: 7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroserviceIcon);
export default __webpack_public_path__ + "static/media/microservice-icon.031cac551ee4deb571926209430fb85a.svg";
export { ForwardRef as ReactComponent };